// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__17soX","content":"ManualTimeModal_content__1nXwn"};